import { GenericTooltip } from "@components/tooltip-container";

import {
  getColors,
  getSentence,
  getTooltipContent,
} from "../metrics/correlation-utils";

interface Props {
  r: number;
  onOpenTooltip(): void;
  onCloseTooltip(): void;
}

export const CorrelationPill = ({
  r,
  onOpenTooltip,
  onCloseTooltip,
}: Props) => {
  const { bgColor, textColor } = getColors(r);
  const tooltipContent = getTooltipContent(r);

  return (
    <GenericTooltip
      onOpen={onOpenTooltip}
      onClose={onCloseTooltip}
      noInfoCircle
      mouseEnterDelay={100}
      content={tooltipContent}
    >
      <div
        className="font-bold text-[9px] px-2.5 rounded-full whitespace-nowrap leading-6"
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        {getSentence(r)}
      </div>
    </GenericTooltip>
  );
};
